import React from "react";

import { styled } from "@mui/material";
import TextField, { TextFieldProps } from "@mui/material/TextField";


const StyledTextField = styled(TextField)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    "& .MuiInputBase-input": {
      fontSize: "0.75rem",
    },
  },
  [theme.breakpoints.down(430)]: {
    "& .MuiInputBase-input": {
      fontSize: "0.65rem",
    },
  },
  [theme.breakpoints.down(380)]: {
    "& .MuiInputBase-input": {
      fontSize: "0.60rem",
    },
  },
}));

const ResponsiveTextField: React.FC<TextFieldProps> = (props) => {
  return <StyledTextField {...props} />;
};

export default ResponsiveTextField;
